module.exports = __webpack_public_path__ + "static/gallery_treehouse_2_thumb-653f7c75fc970916bca18a66ad8bce1b.jpg";